/**
 * Filevine Resources Service - Re-exports from generated service
 *
 * This file wraps the auto-generated filevine resources service to provide:
 * - Stable import path that won't be overwritten by codegen
 * - All generated hooks and types for contacts and documents
 */

import { enhancedApi as generatedApi } from './generated/filevineResourcesService';

// Re-export all types from generated service
export type {
  // Contact types
  FilevineContactAddressSchema,
  FilevineContactByFilevineIdApiArg,
  FilevineContactEmailSchema,
  FilevineContactMatchMetadata,
  FilevineContactPhoneSchema,
  // API arg types
  FilevineContactRetrieveApiArg,
  FilevineContactSchema,
  FilevineContactSearchApiArg,
  FilevineContactSearchFieldType,
  FilevineContactSearchResponse,
  FilevineContactSearchResult,
  FilevineContactWithHandlesSchema,
  // Document types
  FilevineDocumentDetailedSchema,
  FilevineDocumentListApiArg,
  FilevineDocumentListResponse,
  FilevineDocumentRetrieveApiArg,
  FilevineDocumentSchema,
  FilevineDocumentVersionSchema,
  FilevineFolderListApiArg,
  // Folder types
  FilevineFolderSchema,
  FilevineFolderTreeResponse,
  FolderTree,
} from './generated/filevineResourcesService';

// Export the API for store configuration
export const filevineResourcesApi = generatedApi;

// Export hooks from the API
export const {
  // Contact hooks
  useFilevineContactSearchQuery,
  useFilevineContactRetrieveQuery,
  useFilevineContactByFilevineIdQuery,
  // Document hooks
  useFilevineDocumentListQuery,
  useFilevineDocumentRetrieveQuery,
  // Folder hooks
  useFilevineFolderListQuery,
} = generatedApi;
